module.exports = __webpack_public_path__ + "static/technology-icon-82ff4f516b41d1b836c98eeb14563165.png";